import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GlobalFlightBookingDialogComponent } from 'src/app/components/global-dialog/global-flight-booking-dialog/global-flight-booking-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private dialog: MatDialog, ) { }

  PAYMENT_ERROR_HANDLE(res) {
    if (!res) return;
    const errorTag = document.getElementById('ERROR_MESSAGE_SHOW');
    if (!errorTag) return;
    let errorMessage = res.not_found || 
      res.error?.[0]?.msg || 
      Object.values(res.error?.[0]?.errors || {}).flat().join(', ') || 
      Object.values(res.data?.data?.error || {}).flat().join(', ') ||
      res.message || 
      'Something went wrong!';
    if (res.message?.includes('Http failure response')) {
      errorMessage = 'Something went wrong!';
    }
    errorTag.innerText = errorMessage;
  }
  
}
